export default "__VITE_ASSET__CBaOucbD__"